import { useQuery } from 'react-query'
import { QUERY_KEYS } from 'src/constants'
import { accountsService } from 'src/services/accounts.service'

export const useAccountOverrideUrl = (lngCode: string, accountId?: string) => {
  return useQuery(
    [QUERY_KEYS.ACCOUNT_URL, accountId, lngCode],
    () => accountsService.getOverrideUrl(accountId, lngCode),
    {
      refetchOnWindowFocus: false,
      enabled: !!accountId,
    },
  )
}
